export default {
  generateQRCodePath (value: any) {
    return `${value}?_wx_tpl=${value}`
  },
  getFirstPathNameWord (value: any) {
    let array = value.split('/')
    return array[array.length - 1].slice(0,1).toUpperCase()
  },
  getPathName (value: any) {
    let array = value.split('/')
    return array[array.length - 1]
  }
}



// WEBPACK FOOTER //
// ./node_modules/_tslint-loader@3.5.4@tslint-loader!./src/views/home/filters.ts